
import Vue from 'vue';
import { message } from 'ant-design-vue';
import { setAuthToken } from '@/utils/authToken';
import { getMemberMyInfo, loginByPassword } from '../api';
import {
  clearCqccUserInfo,
  normalizeCqccUserInfo,
  saveCqccUserInfo,
} from '../userInfo';

export default Vue.extend({
  name: 'Login',
  data() {
    return {
      account: '',
      isRegister: false,
      password: '',
      submitting: false,
    };
  },
  methods: {
    async handleLogin() {
      if (this.submitting) {
        return;
      }

      if (!this.account) {
        message.error('请输入账号');
        return;
      }

      if (!this.password) {
        message.error('请输入密码');
        return;
      }

      this.submitting = true;

      try {
        const res = (await loginByPassword({
          phone: this.account,
          password: this.password,
        })) as any;
        const token = res && res.data && res.data.token;
        // const token =
        //   'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE4MzU5Mzg0OTIsImp0aSI6IjE3ODQwOTg0OTI4NzYzNjQiLCJpYXQiOjE3ODQwOTg0OTIsImlzcyI6Imh0dHBzOi8vdGVzdHdhcC5jcWNiLmNvbSIsIm5iZiI6MTc4NDA5ODQ5Miwic3ViIjo4NzYzNjR9.lyN-6niUnnGR_Cxb5TKoXK78ZQJyxmTfQ1WN_VPLcHI';

        if (!token) {
          message.error((res && res.message) || '登录失败，请稍后重试');
          return;
        }

        setAuthToken(token);
        clearCqccUserInfo();
        let userInfoLoaded = true;
        try {
          const userInfoRes = await getMemberMyInfo();
          saveCqccUserInfo(normalizeCqccUserInfo(userInfoRes));
        } catch (err) {
          userInfoLoaded = false;
        }
        if (userInfoLoaded) {
          message.success('登录成功');
        } else {
          message.warning('登录成功，用户信息获取失败');
        }
        await this.goHome();
      } catch (err) {
        message.error('登录失败，请稍后重试');
      } finally {
        this.submitting = false;
      }
    },
    showRegisterPanel() {
      this.isRegister = true;
    },
    showLoginPanel() {
      this.isRegister = false;
    },
    getRedirectPath() {
      const redirect = this.$route.query.redirect;
      const redirectPath = Array.isArray(redirect) ? redirect[0] : redirect;

      if (
        typeof redirectPath === 'string' &&
        redirectPath.indexOf('/cqcc/') === 0 &&
        redirectPath !== '/cqcc/login'
      ) {
        return redirectPath;
      }

      return '/cqcc/home';
    },
    goHome() {
      return this.$router
        .replace(this.getRedirectPath())
        .catch((err: Error) => err);
    },
  },
});
